"use client";
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/cosmic/background-patterns.tsx
import { BackgroundGradientElements } from "./background-gradient-elements.js";
import { BackgroundSvgPatterns } from "./background-svg-patterns.js";
import { jsx, jsxs } from "react/jsx-runtime";
function GeometricPatterns({ colorScheme, intensity }) {
  return /* @__PURE__ */ jsxs("div", { className: "absolute inset-0 overflow-hid\
den pointer-events-none", children: [
    /* @__PURE__ */ jsx(BackgroundGradientElements, {}),
    /* @__PURE__ */ jsx(BackgroundSvgPatterns, { colorScheme, intensity })
  ] });
}
__name(GeometricPatterns, "GeometricPatterns");
export {
  GeometricPatterns
};
